module.exports = __webpack_public_path__ + "static/media/32_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_2_5_ccso.6e447b6c.png";